<template>
  <div class="view-home">
    <header
      v-if="headerCourse"
      :style="
        `background-image: linear-gradient(80deg, #001535 -5%, rgba(0, 0, 0, 0.1) 50%), url('${headerCourse.cover}')`
      "
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-5">
            <small>ESCOLA M60</small>
            <h1 class="mb-4">{{ headerCourse.title }}</h1>

            <!-- <div class="row mx-n1 align-items-center mb-5 d-none d-lg-flex">
              <div class="col-6 px-1">
                <div class="progress">
                  <div
                    class="progress-bar btn-success"
                    :style="`width: ${headerCourseProgress}%`"
                  ></div>
                </div>
              </div>
              <div class="col-6 px-1 font-weight-bold">
                {{ headerCourseProgress }}% concluído
              </div>
            </div> -->

            <div
              class="d-flex mx-n2 align-items-center justify-content-center justify-content-lg-start"
            >
              <!-- <action-dispatcher
                class="mx-2"
                action="courses/getDetails"
                :parameters="headerCourse.id"
                small
              >
                <router-link
                  v-if="currentLesson"
                  class="btn btn-primary rounded-pill d-inline-flex align-items-center justify-content-center"
                  :to="{
                    name: 'lesson',
                    params: { ...headerCourse, lesson: currentLesson.id }
                  }"
                >
                  <i class="icon-play"></i>
                </router-link>
              </action-dispatcher> -->
              <router-link
                class="btn btn-primary px-5 d-inline-flex align-items-center mx-2 btn-lg font-weight-bold"
                :to="{
                  name: 'course',
                  params: { ...headerCourse }
                }"
              >
                <i class="icon-play mr-3 my-2"></i> Comece aqui
              </router-link>
            </div>

            <div class="text-center pt-5 d-lg-none">
              <span class="text-grey">Progresso módulo:</span>
              {{ headerCourseProgress }}% concluído
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="container-fluid pt-4">
      <action-dispatcher action="courses/getTrails">
        <trails :list="trails" class="mb-4" />
      </action-dispatcher>

      <action-dispatcher action="courses/getLastLessons">
        <h5 v-if="lastLessons.length" class="my-3">
          Continuar assistindo
        </h5>

        <home-carousel :list="progressCourses">
          <template #default="{data:lesson}">
            <progress-course-card class="flex-fill" :lesson="lesson" />
          </template>
        </home-carousel>
      </action-dispatcher>

      <action-dispatcher action="courses/getRecommendedHome">
        <h5 class="my-3">Recomendado</h5>

        <home-carousel
          :list="recommended"
          :per-page-custom="[
            [200, 1.5],
            [400, 2],
            [600, 3],
            [800, 4],
            [1280, 5],
            [1500, 5.5]
          ]"
        >
          <template #default="{data:course}">
            <course-card :course="course" />
            {{ course.title }}
          </template>
        </home-carousel>
      </action-dispatcher>

      <h5 class="my-3">Simuladores</h5>
      <action-dispatcher action="tools/getAiTools">
        <home-carousel :list="simulators">
          <template #default="{data}">
            <simulator-card :simulator="data" />
          </template>
        </home-carousel>
      </action-dispatcher>

      <action-dispatcher action="courses/getAllLessons">
        <h5 v-if="lessons.length" class="my-3">
          Últimas aulas adicionadas
        </h5>

        <home-carousel :list="lessons">
          <template #default="{data:lesson}">
            <progress-course-card class="flex-fill" :lesson="lesson" />
          </template>
        </home-carousel>
      </action-dispatcher>

      <newsletter />
    </div>

    <b-modal
      hide-footer
      hide-header
      centered
      size="xl"
      v-model="complementDialog"
    >
      <complement-modal @close="complementDialog = false" />
    </b-modal>
  </div>
</template>

<script>
import CourseCard from "@/components/home/CourseCard";
import Trails from "@/components/home/Trails";
import Newsletter from "@/components/home/Newsletter";
import ProgressCourseCard from "@/components/home/ProgressCourseCard";
import ComplementModal from "@/components/templates/ComplementModal";
import get from "lodash/get";
import { mapState } from "vuex";
import HomeCarousel from "../components/home/HomeCarousel.vue";
import SimulatorCard from "../components/home/SimulatorCard.vue";

export default {
  data() {
    return {
      complementDialog: false
    };
  },
  components: {
    Trails,
    CourseCard,
    ProgressCourseCard,
    ComplementModal,
    Newsletter,
    HomeCarousel,
    SimulatorCard
  },
  computed: {
    ...mapState("courses", [
      "courses",
      "lastLessons",
      "lessons",
      "course",
      "trails",
      "recommendedHome"
    ]),
    ...mapState("tools", ["aiTools"]),
    simulators() {
      return this.aiTools.filter(tool => tool.is_simulator);
    },
    headerCourseProgress() {
      return parseInt(get(this.headerCourse, "progress", 0));
    },
    recommended() {
      const recommended = this.recommendedHome.find(r => r.is_section);
      if (recommended && recommended.courses) {
        return this.courses.filter(c => recommended.courses.includes(c.id));
      }
      return null;
    },
    progressCourses() {
      return this.lastLessons
        .concat()
        .sort((a, b) => {
          if (a.progress.updated_at > b.progress.updated_at) {
            return -1;
          }
          if (b.progress.updated_at > a.progress.updated_at) {
            return 1;
          }
          return 0;
        })
        .slice(0, 4);
    },
    headerCourse() {
      return this.courses.find(c => c.progress < 100);
    },
    currentLesson() {
      return (
        this.course &&
        this.course.lessons &&
        this.course.lessons.find(
          lesson => !lesson.progress || !lesson.progress.finished_at
        )
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.view-home {
  header {
    background: url("../assets/images/cover.jpg");
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    position: relative;

    height: 0;
    padding-bottom: 45%;
    width: 100%;

    .container-fluid {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    @media screen and (max-width: 991px) {
      min-height: 400px;
      text-align: center;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: linear-gradient(to bottom, transparent 50%, #000b);
      }

      .container-fluid {
        top: unset;
        left: unset;
        transform: unset;
        bottom: 24px;
      }
    }

    img {
      max-width: 100%;
      width: 300px;

      @media screen and (max-width: 991px) {
        width: 150px;
      }
    }
  }

  .text-grey {
    color: #aaa;
  }
}
</style>
